import loadable from '@loadable/component';
import { isAutoEfectivoYape, isPilotChannelLanding } from 'libs/utils/routes';
import { RoutePaths } from './routes.type';
import MainPageWrapper from './MainPageWrapper';
import SummaryPageWrapper from './SummaryPageWrapper';
import ConfirmationPageWrapper from './ConfirmationPageWrapper';

export const LandingRoutes = {
  component: MainPageWrapper,
  path: RoutePaths.Landing,
  name: 'Landing',
  isPrivate: false,
};

export const QuotationRoutes = {
  component: loadable(() =>
    isPilotChannelLanding(window.location.pathname)
      ? import('../domains/quotation/containers/bex-experience/bex-experience')
      : import.meta.env.VITE_APP_ENABLED_ROUTING
      ? import('../domains/new-quotation/index')
      : import('../domains/quotation/containers/choose-plan/choose-plan'),
  ),
  path: RoutePaths.Quotation,
  name: 'Quotations',
  isPrivate: true,
};

export const NewQuotationRoutes = {
  component: loadable(() => import('../domains/new-quotation/index')),
  path: RoutePaths.NewQuotation,
  name: 'Quotations',
  isPrivate: false,
};

export const SummaryRoutes = {
  component: SummaryPageWrapper,
  path: RoutePaths.Summary,
  name: 'summary',
  isPrivate: isAutoEfectivoYape ? false : true,
};

export const ConfirmationRoutes = {
  component: ConfirmationPageWrapper,
  path: RoutePaths.Confirmation,
  name: 'confirmation',
  isPrivate: true,
};

export const ErrorPaymentRoutes = {
  component: loadable(
    () =>
      import(
        '../domains/quotation/containers/payment/containers/payment-niubiz/payment-niubiz'
      ),
  ),
  path: RoutePaths.ErrorPayment,
  name: 'error-payment',
  isPrivate: true,
};

export const SchedulingRoutes = {
  component: loadable(
    () => import('../domains/scheduling/containers/scheduling'),
  ),
  path: RoutePaths.Scheduling,
  name: 'Scheduling',
  isPrivate: false,
};

export const SchedulingThanksRoutes = {
  component: loadable(
    () =>
      import(
        '../domains/scheduling/containers/registration-page/registration-page'
      ),
  ),
  path: RoutePaths.SchedulingThanks,
  name: 'SchedulingThanks',
  isPrivate: false,
};

export const SchedulingBCPRoutes = {
  component: loadable(
    () => import('../domains/scheduling-bcp/app/page'),
  ),
  path: RoutePaths.SchedulingBCP,
  name: 'Scheduling',
  isPrivate: false,
};

export const SchedulingThanksBCPRoutes = {
  component: loadable(
    () =>
      import(
        '../domains/scheduling-bcp/page/thankPage'
      ),
  ),
  path: RoutePaths.SchedulingBCPThanks,
  name: 'SchedulingThanksBCP',
  isPrivate: false,
};

export const LandingAutoEfectivoRoutes = {
  component: loadable(() => import('../domains/auto-efectivo/containers/app')),
  path: RoutePaths.AutoEfectivoExperiencia,
  name: 'NewLandingAutoefectivo',
  isPrivate: false,
};

export const QuotationAutoEfectivoRoutes = {
  component: loadable(
    () => import('../domains/auto-efectivo/quotation/containers/app'),
  ),
  path: RoutePaths.QuotationAutoEfectivo,
  name: 'QuotationAutoefectivo',
  isPrivate: true,
};

export const PaymentAutoEfectivoRoutes = {
  component: loadable(
    () => import('../domains/auto-efectivo/payment/containers/app'),
  ),
  path: RoutePaths.PaymentAutoEfectivo,
  name: 'PaymentAutoefectivo',
  isPrivate: true,
};

export const ConfirmationAutoEfectivoRoutes = {
  component: loadable(
    () => import('../domains/auto-efectivo/thanks/containers/app-e2e'),
  ),
  path: RoutePaths.ConfirmationAE,
  name: 'ConfirmationAE',
  isPrivate: true,
};
